import React, { useEffect, useState, memo } from 'react';
import { ArrowUpOutlined } from '@ant-design/icons';

const CTASection = () => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setShowTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <section className='py-20 flex justify-center'>
        <div className='w-full max-w-2xl mx-auto bg-gradient-to-br from-[#5a4bff]/70 to-[#18181b] rounded-2xl shadow-2xl p-10 text-center border border-white/10'>
          <h2 className='text-3xl md:text-4xl font-bold mb-4 text-white'>Launch Your First Generation in 60 Seconds — No Setup Required</h2>
          <p className='text-lg text-gray-200 mb-8'>Choose a plan that fits your API usage and generate images and videos on demand with powerful AI models.</p>
          <a
            href='/pricing'
            className='inline-block bg-gradient-to-r from-[#5a4bff] to-[#b74bff] text-white px-8 py-3 rounded-full text-lg font-bold shadow-lg hover:scale-105 focus:ring-2 focus:ring-[#b74bff] transition-all duration-150'
          >
            Explore Plans
          </a>
        </div>
      </section>
      {showTop && (
        <button
          onClick={scrollToTop}
          className='fixed bottom-8 right-7 z-50 bg-white/10 backdrop-blur-lg border border-white/20 text-white p-3 rounded-full hover:bg-primary/70 focus:ring-2 focus:ring-primary'
          aria-label='Back to Top'
        >
          <ArrowUpOutlined style={{ fontSize: 22 }} />
        </button>
      )}
    </>
  );
};

export default memo(CTASection);
